import {
  createOAuthClient,
  deleteOAuthClient,
  fetchOAuthClients,
  updateOAuthClient,
} from "../api/api";

// Action creators for creating OAuth clients
export const addClient = (data) => async (dispatch) => {
  try {
    dispatch({ type: "CLIENT_CREATE_REQUEST" });

    console.log(data);
    const res = await createOAuthClient(data);

    if (res.status === 200) {
      dispatch({
        type: "CLIENT_CREATE_SUCCESS",
        payload: res.data.message,
      });
    } else {
      dispatch({
        type: "CLIENT_CREATE_FAIL",
        payload: res.data,
      });
    }

    return res.data;
  } catch (error) {
    console.log(error);
    dispatch({
      type: "CLIENT_CREATE_FAIL",
      payload: error.response?.data?.message || "Something went wrong",
    });
  }
};

// Action to fetch all OAuth clients
export const getClients = () => async (dispatch) => {
  try {
    const res = await fetchOAuthClients();

    console.log(res);
    dispatch({
      type: "GET_CLIENTS",
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    console.log(err);
  }
};

// Action to update an existing OAuth client
export const updateClient = (id, data) => async (dispatch) => {
  try {
    dispatch({ type: "CLIENT_UPDATE_REQUEST" });

    const res = await updateOAuthClient(id, data);

    dispatch({
      type: "CLIENT_UPDATE_SUCCESS",
      payload: res.data,
    });
    return true;
  } catch (error) {
    dispatch({
      type: "CLIENT_UPDATE_FAIL",
      payload: error.response?.data?.message || "Something went wrong",
    });
    return false;
  }
};

// Action to delete an OAuth client
export const removeClient = (id) => async (dispatch) => {
  try {
    dispatch({ type: "CLIENT_DELETE_REQUEST" });
    const res = await deleteOAuthClient(id);

    dispatch({
      type: "CLIENT_DELETE_SUCCESS",
      payload: res.data,
    });
    return true;
  } catch (error) {
    dispatch({
      type: "CLIENT_DELETE_FAIL",
      payload: error.response?.data?.message || "Something went wrong",
    });
    return false;
  }
};
